import React from 'react';

const DashboardLayout = ({ title, description, filters, children }) => {
  return (
    <div className="space-y-6">
      <section className="mb-2">
        <h1 className="text-2xl font-bold mb-1">{title}</h1>
        {description && <p className="text-gray-600">{description}</p>}
      </section>
      <section className="sticky top-16 z-20 bg-gray-50 pb-3">
        <div className="bg-white p-4 rounded-lg shadow-md">
          <div className="w-full">{filters}</div>
        </div>
      </section>
      {children}
    </div>
  );
};

export default DashboardLayout;
